import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppData } from '../../context/AppDataContext';
import { useOptionalStore } from '../../context/StoreContext';
import { applyStoreFavicon } from '../../utils/documentMeta';
import { isSubdomainStoreMode } from '../../utils/storeUtils';

const isCustomerRoute = (pathname) => (
  isSubdomainStoreMode() || pathname.startsWith('/stores/')
);

const StoreFaviconSync = () => {
  const location = useLocation();
  const { currentStore } = useAppData();
  const storeContext = useOptionalStore();
  const faviconUrl = isCustomerRoute(location.pathname)
    ? storeContext?.storeOverview?.brandingImages?.faviconUrl
    : currentStore?.faviconUrl;

  useEffect(() => {
    applyStoreFavicon(faviconUrl);
  }, [faviconUrl]);

  return null;
};

export default StoreFaviconSync;
